import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import $ from "jquery";
import "antd/dist/reset.css";
import "./utils/i18n";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import reportWebVitals from "./reportWebVitals";
import store, { Persistor } from "./store";
import App from "./App";

// Set jQuery globally to be accessed as window.jQuery
window.jQuery = $;

// Require Bootstrap for jQuery-dependent components
require("bootstrap");

// Create a root for ReactDOM rendering
const root = ReactDOM.createRoot(document.getElementById("root"));

// Render the main application within React Strict Mode
root.render(
  <React.StrictMode>
    {/* Use BrowserRouter for client-side routing */}
    <BrowserRouter>
      {/* Provide the Redux store to the entire application */}
      <Provider store={store}>
        {/* Use PersistGate for Redux state persistence during page reloads */}
        <PersistGate loading={null} persistor={Persistor}>
          {/* Render the main application component */}
          <App />
        </PersistGate>
      </Provider>
    </BrowserRouter>
  </React.StrictMode>
);

// Report web vitals to the console or external service
reportWebVitals();
